
import {defineComponent} from "vue";

export default defineComponent({
    name: "RadioButton",
    inheritAttrs: false,
    props: {
        label: {type: [String, Boolean], required: true},
        isChecked: {type: Boolean}
    },
    emits: ["change"],
    methods: {
        emitChange(): void {
            this.$emit("change", {
                id: this.$attrs.id,
                label: this.label,
                name: this.$attrs.name
            });
        },
        handleClick(): void {
            const checkboxBtn = this.$refs.checkbox as HTMLInputElement
            checkboxBtn.checked = !checkboxBtn.checked
            this.emitChange()
        },
        handleOnInput() {
            this.emitChange()
        }
    }
})
